import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key] === "status") {
        return `${key}=${parseInt(params[key])}&`;
      } else if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };
    try {
      const response = await api[method](
        `${endpoint}?${getParams("_id")}${getParams("from_date")}${getParams(
          "to_date"
        )}${getParams("status")}${getParams(
          "sort_by"
        )}sort_order=${params?.sort_order || ""}&page_size=${
          params?.page_size || "10"
        }&${getParams("search")}&page=${params?.page || 1}&${getParams(
          "length"
        )}`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err.response?.data || err.message,
      };
    }
  };

export const users = createApi({
  reducerPath: "usersApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Users","UsersId"],
  endpoints: (builder) => ({
    getUsersListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/user/list`,
      }),
      provideTags: ["Users"],
    }),
    getUserFormDataById: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `admin/user/profile-view`,
      }),
      provideTags: ["UsersId"],
    }),
    updateUsersListData: builder.mutation({
      query: (body) => ({
        method: "put",
        body,
        endpoint: `/admin/user/update`,
      }),

      invalidatesTags: ["Users"],
    }),
    deleteUserData: builder.mutation({
      query: (values) => ({
        method: "delete",
        params: values,
        endpoint: `/admin/user/delete`,
      }),

      invalidatesTags: ["Users"],
    }),
    getFilterListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/filters/common-search-filters`,
      }),
      invalidatesTags: ["Users"],
    }),
    statusChange: builder.mutation({
      query: (values) => ({
        method: "post",
        params: values,
        endpoint: `/admin/user/change-user-status`,
      }),
    }),
  }),
});

export const {
  useGetUsersListDataQuery,
  useGetUserFormDataByIdQuery,
  useUpdateUsersListDataMutation,
  useDeleteUserDataMutation,
  useGetFilterListDataQuery,
  useStatusChangeMutation,
} = users;
